import "./About.module.css";
import Header from "@/reusable_sections/Header";
import TheRuchniiStory from "./sections/TheRuchniiStory";
import OurMilestones from "./sections/OurMilestones";
import StudioFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <TheRuchniiStory />
      <OurMilestones />
      <StudioFooter />
    </div>;
}